// Stores constants that may be shared between certain Feedback Widget components and tests

// ALT TEXT
export const CLOSE_BUTTON_ALT_TEXT = 'Close Feedback Form';
export const SCREENSHOT_OVERLAY_ALT_TEXT = 'Screenshot';

// TEXT
export const RATING_QUESTION_TEXT = 'How would you rate this page?';
export const COMMENT_PLACEHOLDER_TEXT = 'Tell us more about your experience';
export const COMMENT_PLACEHOLDER_TEXT_LOW = 'Tell us how we can improve';
export const EMAIL_PLACEHOLDER_TEXT = 'Email Address';
export const EMAIL_ERROR_TEXT = 'Please enter a valid email.';
export const SCREENSHOT_BUTTON_TEXT = 'Show us a screenshot';
export const SCREENSHOT_BUTTON_TEXT_LOW = 'Show us where the problem is';
export const FEEDBACK_SUBMIT_BUTTON_TEXT = 'Send';

export const SUBMITTED_VIEW_TEXT = {
  HEADING: 'Thank you for your feedback!',
  SUB_HEADING: "Your input improves MongoDB's Documentation.",
  RESOURCES_CTA: 'Looking for more resources?',
  SUPPORT_CTA: 'Have a support contact?',
};

export const SUBMITTED_VIEW_RESOURCE_LINKS = [
  { text: 'MongoDB Developer Community Forums', href: 'https://www.mongodb.com/community/forums/' },
  { text: 'MongoDB Developer Center', href: 'https://www.mongodb.com/developer/' },
  { text: 'MongoDB University', href: 'https://learn.mongodb.com/' },
];

export const SUBMITTED_VIEW_SUPPORT_LINK = {
  text: 'Create a Support Case',
  href: 'https://support.mongodb.com/?_ga=2.191926057.2087449804.1701109748-1659791399.1655906873&_gac=1.114903413.1698074435.CjwKCAjws9ipBhB1EiwAccEi1AOuCPf5YadKdTucTL0245YGXrgMbNUsNrZLHXWf-WX73dnW1DOzZBoCR-QQAvD_BwE',
};
